import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          url: Yup.string()
                                                   .url('Must be a valid URL')
                                                   .required('Required'),
                                          viewportWidth: Yup.number()
                                                            .nullable()
                                                            .min(320, 'Minimum width is 320')
                                                            .max(3840, 'Maximum width is 3840'),
                                          viewportHeight: Yup.number()
                                                             .nullable()
                                                             .min(240, 'Minimum height is 240')
                                                             .max(2160, 'Maximum height is 2160'),
                                          delay: Yup.number()
                                                     .nullable()
                                                     .min(0, 'Delay cannot be negative')
                                                     .max(30000, 'Maximum delay is 30 seconds'),
                                          deviceScaleFactor: Yup.number()
                                                                 .nullable()
                                                                 .min(1, 'Minimum scale is 1')
                                                                 .max(3, 'Maximum scale is 3'),
                                      });
